import React, { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Box } from "@mui/material";

import EventOrgazinationProfile from "./EventOrgazinationProfile";
import EventOrgazinationTranactions from "./EventOrgazinationTranactions";
import EventOrgazinationEvents from "./EventOrgazinationEvents";
import EventOrgazinationTeams from "./EventOrgazinationTeams";
import EventOrgazinationInvestorCSV from "./EventOrgazinationInvestorCSV";
import EventOrgazinationNews from "./EventOrgazinationNews";

const EventOrgazinationTabs = (props) => {
  const { module } = props;
  const { accountId, tabType } = useParams();
  const userTabs = useMemo(
    () => ({
      profile: "Profile",
      teams: "Teams",
      events: "Events",
      news: "news",
      transactions: "Transactions",
    }),
    []
  );

  const [ToggleState, setToggleState] = useState();

  useEffect(() => {
    setToggleState(userTabs?.[tabType] ? tabType : "profile");
  }, [tabType, userTabs]);

  return (
    <Box className="managepro6ix-layout-page-content">
      <div className="managepro6ix-layout-page-content-header">
        <div className="managepro6ix-layout-page-content-header-left">
          <div className="managepro6ix-layout-page-content-header-menu">
            {Object.keys(userTabs).map((item, key) => (
              <Link
                key={key}
                to={`/events/organization/${accountId}/${item}`}
                className={`managepro6ix-layout-page-content-header-menu-link ${
                  ToggleState === item ? "active" : ""
                }`}
              >
                {userTabs[item]}
              </Link>
            ))}
          </div>
        </div>
        <div className="managepro6ix-layout-page-content-header-action">
          <EventOrgazinationInvestorCSV />
        </div>
      </div>
      {ToggleState === "profile" ? (
        <EventOrgazinationProfile />
      ) : ToggleState === "teams" ? (
        <EventOrgazinationTeams module={module} />
      ) : ToggleState === "events" ? (
        <EventOrgazinationEvents module={module} />
      ) : ToggleState === "news" ? (
        <EventOrgazinationNews module={module} />
      ) : ToggleState === "transactions" ? (
        <EventOrgazinationTranactions module={module} />
      ) : null}
    </Box>
  );
};

export default EventOrgazinationTabs;
